module.exports = __webpack_public_path__ + "static/media/Down.52b07501.svg";